import React, { useEffect, useState, useCallback } from "react";
import {
  Heart,
  ArrowLeft,
  Filter,
  Grid,
  List,
  MapPin,
  Cake,
  GraduationCap,
  Briefcase,
} from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { State, City } from "country-state-city";
import {
  // Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import Select from "react-select";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { Slider } from "./ui/slider";
import { Switch } from "./ui/switch";
import { Label } from "./ui/label";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { Header } from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { Horizontalslider } from "./horizontalslider.jsx";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import { setCurrentPage } from "../redux/navigationSlice.js";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { Footer } from "./Footer.jsx";
import { useNavigate } from "react-router-dom";
import { TrendingProfilesSlider } from "./Trending-profile-slider.jsx";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Sparkles, Funnel, ChevronDown, Calendar } from "lucide-react";
import { motion } from "framer-motion";
import { Popover, Box, Typography } from "@mui/material";
import { setProfileCount } from "../redux/profileCountSlice.js";

// ✅ SVG Icons
const TodayIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <circle cx="12" cy="15" r="1" fill="currentColor"></circle>
    <circle cx="16" cy="15" r="1" fill="currentColor"></circle>
    <circle cx="8" cy="15" r="1" fill="currentColor"></circle>
  </svg>
);

const WeekIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M8 2v4"></path>
    <path d="M16 2v4"></path>
    <rect x="3" y="4" width="18" height="18" rx="2"></rect>
    <path d="M3 10h18"></path>
    <path d="M8 14h.01"></path>
    <path d="M12 14h.01"></path>
    <path d="M16 14h.01"></path>
    <path d="M8 18h.01"></path>
    <path d="M12 18h.01"></path>
    <path d="M16 18h.01"></path>
  </svg>
);

const BrowsePage = ({ onNavigate }) => {
  const [viewMode, setViewMode] = useState("grid");
  const [profileList, setProfileList] = useState([]);
  var layoutType = "vertical";
  const [allProfiles, setAllProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const completion = useSelector((state) => state.completion.value);
  const [openCompletionDialog, setOpenCompletionDialog] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [ShowSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const [loadingAll, setLoadingAll] = useState(false);
  const [loadingFiltered, setLoadingFiltered] = useState(false);

  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const { t, i18n } = useTranslation();

  // FILTER STATES

  const [open, setOpen] = useState(false);

  const [filterAnchor, setFilterAnchor] = useState(null);

  const [period, setPeriod] = useState("all");

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 500);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // OPEN FILTER

  const handleFilterClick = (event) => {
    setFilterAnchor(event.currentTarget);

    setOpen(true);
  };

  // CLOSE FILTER

  const handleFilterClose = () => {
    setOpen(false);

    setFilterAnchor(null);
  };

  // HANDLE DATE FILTER CHANGE

  const handlePeriodChange = (value) => {
    if (period === value) {
      // 🔁 Toggle OFF (clear filter)
      setPeriod("all");
      console.log("Period cleared");
    } else {
      // ✅ Apply new filter
      setPeriod(value);
      console.log("Selected Period:", value);
    }
    // You can filter viewerProfiles here if needed
    handleFilterClose();
    console.log("Selected Period:", value);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sentInterestIds, setSentInterestIds] = useState([]);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  console.log(page, "PAGE", "COUNT", count);

  const [filters, setFilters] = useState({
    ageRange: [22, 35],
    location: "",
    religion: "",
    education: "",
    profession: "",
    onlineOnly: false,
    state: "",
    district: "",
  });

  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  useEffect(() => {
    const states = State.getStatesOfCountry("IN");
    setStatesList(states);
  }, []);

  const statesOptions = statesList.map((item) => ({
    value: item.name,
    label: item.name,
    isoCode: item.isoCode,
  }));

  const districtsOptions = districtList.map((d) => ({
    value: d,
    label: d,
  }));

  // On State Change
  const handleStateChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedState("");
      setDistrictList([]);
      return;
    }

    setSelectedState(selectedOption.value);

    const stateObj = statesList.find(
      (item) => item.name === selectedOption.value
    );

    if (stateObj) {
      const cities = City.getCitiesOfState("IN", stateObj.isoCode);
      setDistrictList(cities.map((c) => c.name));
    }
  };

  const religionList = [
    "Hindu",
    "Christian",
    "Muslim",
    "Buddhist",
    "Jain",
    "Sikh",
    "No Religion Barrier",
  ];

  const educationList = [
    "No formal education",
    "Primary school",
    "High school / SSLC",
    "Higher secondary / HSC",
    "Diploma",
    "ITI / Vocational training",
    "Undergraduate (UG)",
    "Bachelor’s degree",
    "Postgraduate (PG)",
    "Master’s degree",
    "M.Phil",
    "Doctorate / Ph.D",
    "Professional degree (CA / CS / CFA / ICAI)",
    "Medical degree (MBBS / MD / MS)",
    "Engineering degree (BE / BTech / ME / MTech)",
    "Any degree",
    "Other",
  ];

  useEffect(() => {
    const fetchInterests = async () => {
      if (!token || !id) return;

      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}`
        );

        const receivers = sentresponse?.data?.receivers || [];

        if (receivers.length > 0) {
          const receiverIds = receivers.map((r) => r.user_id);
          setSentInterestIds(receiverIds);
          console.log("Receiver IDs stored:", receiverIds);
        } else {
          setSentInterestIds([]);
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setSentInterestIds([]);
      }
    };
    fetchInterests();
  }, []);

  const fetchAllProfiles = useCallback(async () => {
    setLoading(true);
    try {
      let response;
      if (token && id) {
        response = await getWithTokenAPI(
          token,
          `/basic-profile/get_others?user_id=${id}&page=${count}&period=${period}`
        );
      } else {
        response = await getWithoutTokenAPI(
          `/basic-profile/get_all?page=${1}&limit=${10}`
        );
      }

      if (response?.statusCode === 200) {
        setAllProfiles(response?.data?.profiles || []);
        setPage(response?.data?.totalPages);
      }
    } catch (err) {
      console.error("Error fetching all profiles:", err);
    } finally {
      setLoading(false);
    }
  }, [token, id, count, period]);

  useEffect(() => {
    fetchAllProfiles();
  }, [fetchAllProfiles]);

  const fetchFilteredProfiles = useCallback(
    async (mode = "filter", searchValue = "", customFilters = filters) => {
      setLoading(true);
      try {
        let response;

        //       // --- SEARCH MODE ---
        if (mode === "search" && searchValue.trim() !== "") {
          if (token && id) {
            response = await getWithTokenAPI(
              token,
              `/basic-profile/get_all?search=${encodeURIComponent(searchValue)}`
            );
          } else {
            response = await getWithoutTokenAPI(
              `/basic-profile/get_all?search=${encodeURIComponent(searchValue)}`
            );
          }
        }

        //       // --- FILTER MODE ---
        else {
          const payload = {};

          if (customFilters.location) payload.city = customFilters.location;
          if (customFilters.profession)
            payload.profession = customFilters.profession;
          if (customFilters.religion) payload.religion = customFilters.religion;
          if (customFilters.ageRange?.[0])
            payload.fromAge = customFilters.ageRange[0];
          if (customFilters.ageRange?.[1])
            payload.toAge = customFilters.ageRange[1];
          if (selectedState) payload.state = selectedState;
          if (customFilters.district) payload.district = customFilters.district;

          if (token && id) {
            // ✅ Send payload as POST body
            response = await postWithTokenAPI(
              token,
              `/profile/filter?user_id=${id}`,
              payload
            );
          } else {
            setShowLoginDialog(true);
          }
        }

        if (response?.statusCode === 200) {
          setFilteredProfiles(response?.data?.profiles || []);
        } else {
          setFilteredProfiles([]);
        }
      } catch (error) {
        console.error("Error fetching filtered profiles:", error);
        setFilteredProfiles([]);
      } finally {
        setLoading(false);
      }
    },
    [token, id, filters]
  );

  const handleProfileClick = async (profile) => {
    const progress = Math.round((completion / 4) * 100);
    if (!token) {
      setShowLoginDialog(true);
    }
    try {
      const profileId = profile?.basicProfile?.user_id || profile?.user_id;
      const profilename = profile?.basicProfile?.name || profile?.name;
      if (!profileId) {
        console.warn("No profile id found for", profile);
        return;
      }
      if (progress > 75) {
        const payload = { viewer_id: id, viewed_id: profileId };
        const response = await postWithTokenAPI(
          token,
          `/profile-view/track`,
          payload
        );
        if (response?.statusCode === 200) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          navigate(`/view-profile/${profilename}`, {
            state: { profileId: profileId },
          });
          dispatch(
            setProfileCount(response?.data?.unique_profiles_viewed_today)
          );
        } else if (response?.statusCode === 403) {
          setShowSubscribeDialog(true);
        } else {
          console.log(response);
        }
      } else {
        setOpenCompletionDialog(true);
      }
    } catch (error) {
      console.error("Error in viewed profile post", error);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm.trim() === "") {
        setFilteredProfiles([]);
      } else {
        fetchFilteredProfiles("search", searchTerm);
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchTerm, fetchFilteredProfiles]);

  // useEffect(() => {
  //   const delay = setTimeout(() => {
  //     const activeFilter =
  //       filters.location ||
  //       filters.religion ||
  //       filters.education ||
  //       filters.profession ||
  //       filters.onlineOnly ||
  //       filters.ageRange[0] !== 22 ||
  //       filters.ageRange[1] !== 35;

  //     if (activeFilter) fetchFilteredProfiles("filter", "", filters);
  //     else setFilteredProfiles([]);
  //   }, 500);
  //   return () => clearTimeout(delay);
  // }, [filters, fetchFilteredProfiles]);

  useEffect(() => {
    if (!filteredProfiles.length) return;

    setFilteredProfiles((prevList) => {
      const updatedList = prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      });
      const isSame =
        JSON.stringify(prevList.map((i) => i.interest)) ===
        JSON.stringify(updatedList.map((i) => i.interest));

      return isSame ? prevList : updatedList;
    });
  }, [sentInterestIds, filteredProfiles]);

  useEffect(() => {
    if (!allProfiles.length) return;

    setAllProfiles((prevList) => {
      const updatedList = prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      });
      const isSame =
        JSON.stringify(prevList.map((i) => i.interest)) ===
        JSON.stringify(updatedList.map((i) => i.interest));

      return isSame ? prevList : updatedList;
    });
  }, [sentInterestIds, allProfiles]);

  const renderProfiles = (profiles) =>
    viewMode === "grid" ? (
      <div className="grid grid-cols-1 md:grid-cols-1 xl:grid-cols-1 gap-6 pb-6">
        <Horizontalslider
          profiles={profiles}
          layoutType="vertical"
          onNavigate={(profile) => {
            const id = profile?.basicProfile?.user_id || profile?.user_id;
            console.log("Clicked profile id:", id);
            handleProfileClick(profile);
          }}
        />
      </div>
    ) : (
      <div className="space-y-4">
        <Horizontalslider
          profiles={profiles}
          layoutType="vertical"
          onNavigate={(profile) => {
            const id = profile?.basicProfile?.user_id || profile?.user_id;
            console.log("Clicked profile id:", id);
            handleProfileClick(profile);
          }}
        />
      </div>
    );

  const [sortBy, setSortBy] = useState("relevance");

  // ✅ Unified fetchProfiles function
  const fetchProfiles = useCallback(
    async (mode = "default", searchValue = "", customFilters = filters) => {
      setLoading(true);
      try {
        let response;

        // --- SEARCH MODE ---
        if (mode === "search" && searchValue.trim() !== "") {
          if (token && id) {
            response = await getWithTokenAPI(
              token,
              `/basic-profile/get_all?search=${encodeURIComponent(searchValue)}`
            );
          } else {
            response = await getWithoutTokenAPI(
              `/basic-profile/get_all?search=${encodeURIComponent(searchValue)}`
            );
          }
        }

        // --- FILTER MODE ---
        else if (mode === "filter") {
          const payload = {};
          if (customFilters.location) payload.city = customFilters.location;
          if (customFilters.profession)
            payload.profession = customFilters.profession;
          if (customFilters.religion) payload.religion = customFilters.religion;
          if (customFilters.ageRange?.[0])
            payload.fromAge = customFilters.ageRange[0];
          if (customFilters.ageRange?.[1])
            payload.toAge = customFilters.ageRange[1];

          if (token && id) {
            // ✅ Send payload as POST body
            response = await postWithTokenAPI(
              token,
              `/profile/filter?user_id=${id}`,
              payload
            );
          } else {
            setShowLoginDialog(true);
          }
          setIsFilterApplied(true);
          if (response?.statusCode === 200) {
            setFilteredProfiles(response?.data?.profiles || []);
          } else {
            setFilteredProfiles([]);
          }
        }

        // --- DEFAULT MODE ---
        else {
          if (token && id) {
            response = await getWithTokenAPI(
              token,
              `/basic-profile/get_others?user_id=${id}&page=${count}`
            );
          } else {
            response = await getWithoutTokenAPI(`/basic-profile/get_all`);
          }

          if (response?.statusCode === 200) {
            setProfileList(response?.data?.profiles || []);
          } else {
            setProfileList([]);
          }
        }
      } catch (error) {
        console.error("Error fetching profiles:", error);
        setProfileList([]);
      } finally {
        setLoading(false);
      }
    },
    [token, id, filters]
  );

  // ✅ Initial load
  useEffect(() => {
    fetchProfiles("default");
  }, [token, id, fetchProfiles]);

  // ✅ Search input handler (debounced)
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim() === "") fetchProfiles("default");
      else fetchProfiles("search", searchTerm);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm, fetchProfiles]);

  // ✅ Auto-filter whenever filters change (debounced)
  useEffect(() => {
    const delay = setTimeout(() => {
      // Only trigger if any filter field is filled
      if (
        filters.location ||
        filters.religion ||
        filters.education ||
        filters.profession ||
        filters.onlineOnly ||
        filters.ageRange[0] !== 22 ||
        filters.ageRange[1] !== 35
      ) {
        fetchProfiles("filter", "", filters);
      } else {
        fetchProfiles("default");
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [filters, fetchProfiles]);

  const handleInterestToggle = async (profile) => {
    try {
      const payload = {
        from_user_id: id,
        to_user_id: profile?.user_id || profile?.basicProfile?.user_id,
      };

      const response = await postWithTokenAPI(
        token,
        `/interest/create`,
        payload
      );

      if (response?.statusCode === 200) {
        toast.success(`${t("Interest Sent Successfully")}`);
        window.location.reload();
        // setFilteredProfiles((prevProfiles) =>
        //   prevProfiles.map((p) =>
        //     (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
        //       ? { ...p, interest: true }
        //       : p
        //   )
        // );
        // setAllProfiles((prevProfiles) =>
        //   prevProfiles.map((p) =>
        //     (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
        //       ? { ...p, interest: true }
        //       : p
        //   )
        // );
      } else {
        toast.error(`${t("Failed to send interest ")}`);
      }
    } catch (error) {
      console.error("❌ Error sending interest:", error);
      toast.error(`${t("Something went wrong while sending interest!")}`);
    }
  };

  console.log(filteredProfiles, "filteredProfiles====");

  // ✅ UI
  return (
    <div className="min-h-screen bg-background">
      <Toaster position="top-right" />
      <Helmet>
        <title>Aishwarya matrimony - Browse</title>
        <meta name="description" content="This is my page description." />
        <meta name="keywords" content="React, Helmet, SEO" />
      </Helmet>

      <Header />
      {/* Top Bar */}
      <div style={{ width: "100%", display: "flex", marginTop: "2vh" }}>
        <input
          type="text"
          placeholder={t("Search profiles...")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border rounded-md p-2 text-sm w-80"
          style={{
            width: "47%",
            justifyContent: "center",
            // border: "1px solid grey",
            margin: "2vh auto",
          }}
        />
      </div>

      {/* Main Layout */}
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Filters */}
          <div className="lg:col-span-1 sticky top-24 self-start">
            <div className="relative">
              <Card
                className={`${!token ? "opacity-40 blur-sm pointer-events-none" : ""
                  }`}
              >
                <CardContent className="p-6 space-y-6">
                  <div className="flex items-center space-x-2 mb-2">
                    <Filter className="h-5 w-5" />
                    <h2 className="text-lg">{t("Filters")}</h2>
                  </div>

                  {/* Age Range */}
                  <div>
                    <Label className="text-sm mb-3 block">
                      {t("Age Range")}
                    </Label>
                    <Slider
                      value={filters.ageRange}
                      onValueChange={(value) =>
                        setFilters((f) => ({ ...f, ageRange: value }))
                      }
                      min={18}
                      max={50}
                      step={1}
                      className="cursor-pointer"
                      rangeStyle={{
                        background: "linear-gradient(to right bottom, #008000, #005000)",
                      }}
                      thumbClassName="border-emerald-700 hover:ring-emerald-100 focus-visible:ring-emerald-100"
                    />
                    <div className="flex justify-between text-xs mt-2 text-muted-foreground ">
                      <span>
                        {filters.ageRange[0]}
                        {t(" years")}
                      </span>
                      <span>
                        {filters.ageRange[1]} {t("years")}
                      </span>
                    </div>
                  </div>
                  <div>
                    <Label className="text-sm mb-3 block">
                      {t("Religion")}
                    </Label>
                    <Select
                      value={
                        filters.religion
                          ? {
                            value: filters.religion,
                            label: filters.religion,
                          }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilters((f) => ({
                          ...f,
                          religion: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={religionList.map((religion) => ({
                        value: religion,
                        label: religion,
                      }))}
                      placeholder={t("Select Religion")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md bg-white ${state.isFocused
                            ? "border-blue-500 ring-2 ring-blue-200"
                            : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${state.isSelected
                            ? "bg-blue-500 text-white"
                            : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                      }}
                    />
                  </div>

                  <div>
                    <label className="text-sm mb-3 block">{t("State")}</label>
                    <Select
                      value={
                        selectedState
                          ? { value: selectedState, label: selectedState }
                          : null
                      }
                      onChange={handleStateChange}
                      options={statesOptions}
                      placeholder={t("Select State")}
                      isClearable
                      className="react-select-container cursor-pointer"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md bg-white ${state.isFocused
                            ? "border-blue-500 ring-2 ring-blue-200"
                            : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${state.isSelected
                            ? "bg-blue-500 text-white"
                            : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                      }}
                    />
                  </div>

                  <div>
                    <label className="text-sm mb-3 block">
                      {t("District")}
                    </label>
                    <Select
                      value={
                        filters.district
                          ? { value: filters.district, label: filters.district }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilters((f) => ({
                          ...f,
                          district: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={districtsOptions}
                      placeholder={t("Select District")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md bg-white ${state.isFocused
                            ? "border-blue-500 ring-2 ring-blue-200"
                            : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${state.isSelected
                            ? "bg-blue-500 text-white"
                            : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                      }}
                    />
                  </div>

                  <div>
                    <Label className="text-sm mb-3 block">
                      {t("Education")}
                    </Label>

                    <Select
                      value={
                        filters.education
                          ? {
                            value: filters.education,
                            label: filters.education,
                          }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setFilters((f) => ({
                          ...f,
                          education: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={educationList.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      placeholder={t("Select Education")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) =>
                          `text-sm border rounded-md  bg-white ${state.isFocused
                            ? "border-blue-500 ring-2 ring-blue-200"
                            : "border-gray-300"
                          }`,
                        option: (state) =>
                          `text-sm ${state.isSelected
                            ? "bg-blue-500 text-white"
                            : state.isFocused
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-900"
                          }`,
                        menu: () =>
                          "border border-gray-200 rounded-md shadow-lg",
                        placeholder: () => "text-gray-400 text-sm",
                        singleValue: () => "text-gray-900 text-sm",
                        clearIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                        dropdownIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                      }}
                    />
                  </div>

                  <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-3">
                    {/* Clear Filters Button */}
                    <Button
                      variant="outline"
                      className="
      w-full 
      border border-gray-300 
      text-gray-700 
      py-2.5
      rounded-xl
      font-medium
      hover:bg-gray-100 
      hover:border-gray-400
      transition-all 
      cursor-pointer
    "
                      onClick={() =>
                        setFilters({
                          ageRange: [22, 35],
                          location: "",
                          religion: "",
                          education: "",
                          profession: "",
                          onlineOnly: false,
                        })
                      }
                    >
                      {t("Clear Filters")}
                    </Button>

                    {/* Apply Filters Button */}
                    <Button
                      className="
      w-full 
      bg-maroon-gradient
      text-white 
      font-semibold
      py-2.5
      rounded-xl
      shadow-lg
      hover:shadow-xl
      transition-all
      cursor-pointer
      tracking-wide
    "
                      onClick={() => {
                        // Call fetchFilteredProfiles with current filters
                        fetchFilteredProfiles("filter", "", filters);
                      }}
                    >
                      {t("Apply Filters")}
                    </Button>
                  </div>
                </CardContent>
              </Card>
              {!token && (
                <div
                  className="absolute inset-0 flex flex-col items-center justify-center rounded-xl z-50"
                  style={{
                    backgroundColor: "rgba(255, 251, 251, 0.5)", // White color with 50% opacity
                    backdropFilter: "blur(1px)", // Increased blur for better effect
                    border: "1px solid rgba(138, 133, 133, 0.7)",
                  }}
                >
                  <p className="text-black text-sm mb-3 font-medium">
                    {t("Please login to access filters")}
                  </p>

                  <Button
                    onClick={() => navigate("/login")}
                    className="w-[20px] bg-maroon-gradient cursor-pointer"
                  >
                    Login
                  </Button>
                </div>
              )}
            </div>
          </div>

          <div className="lg:col-span-3  space-y-10">
            {searchTerm !== "" || isFilterApplied ? (
              filteredProfiles && filteredProfiles.length > 0 ? (
                <div className="border-b" style={{ marginBottom: "5vh" }}>
                  <h2
                    className="text-2xl font-semibold"
                    style={{ marginBottom: "2vh" }}
                  >
                    {t("Filtered")} / {t("Search Results")}
                  </h2>
                  {loading ? (
                    <p className="text-muted-foreground text-center py-6">
                      {t("Loading profiles...")}
                    </p>
                  ) : (
                    renderProfiles(filteredProfiles)
                  )}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
                  {/* Modern Icon */}
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl flex items-center justify-center mb-6 shadow-sm">
                    <svg
                      className="w-10 h-10 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>

                  {/* Heading with better typography */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 tracking-tight">
                    {t("No profiles found")}
                  </h3>

                  {/* Description with improved spacing */}
                  <p className="text-gray-500 max-w-md text-base leading-relaxed mb-6">
                    {t(
                      "Try adjusting your search criteria or filters to find profiles that match your needs."
                    )}
                  </p>
                </div>
              )
            ) : null}
            <div className="overflow-y-auto no-scrollbar">
              <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {token && (
                  <div
                    className="flex justify-between items-center"
                    style={{ marginBottom: "15px" }}
                  >
                    <div>
                      <h2 className="text-2xl font-bold text-gray-900">
                        {t("All Profiles")}
                      </h2>
                    </div>

                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={handleFilterClick}
                      style={{ height: "4vh", padding: "20px" }}
                      className="flex items-center gap-2 px-3 py-2 border border-red-500 rounded-xl text-red-600 font-semibold hover:shadow-lg transition-all duration-300 w-fit cursor-pointer"
                    >
                      <Funnel size={18} />
                      {!isMobile && (
                        <span className="inline sm:hidden">{t("Filter")}</span>
                      )}
                      <ChevronDown size={16} />
                    </motion.button>
                  </div>
                )}

                <Popover
                  open={open}
                  anchorEl={filterAnchor}
                  onClose={handleFilterClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  sx={{
                    "& .MuiPopover-paper": {
                      borderRadius: "16px",
                      boxShadow: "0 20px 40px rgba(220, 38, 38, 0.15)",
                      border: "1px solid #FACC15",
                      marginTop: "8px",
                      minWidth: "220px",
                      overflow: "hidden",
                    },
                  }}
                >
                  <Box sx={{ p: 3 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "#DC2626",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 3,
                        fontSize: "14px",
                      }}
                    >
                      <Calendar size={16} />
                      {t("Select Period")}
                    </Typography>

                    {/* Options */}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      {[
                        {
                          value: "today",
                          label: t("Today"),
                          icon: <TodayIcon />,
                        },
                        {
                          value: "week",
                          label: t("This Week"),
                          icon: <WeekIcon />,
                        },
                        {
                          value: "month",
                          label: t("This Month"),
                          icon: <WeekIcon />,
                        },
                      ].map((option) => (
                        <motion.button
                          key={option.value}
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => handlePeriodChange(option.value)}
                          className={`flex items-center gap-3 px-4 py-3 rounded-xl border transition-all duration-300 font-semibold cursor-pointer
                          ${period === option.value
                              ? "text-white shadow-lg"
                              : "bg-white text-gray-700 border border-gray-200 hover:bg-rose-50 hover:text-rose-600 hover:border-rose-300"
                            }`}
                          style={{
                            background: period === option.value ? "linear-gradient(to bottom right, #DC2626, #991B1B)" : "",
                            borderColor: period === option.value ? "#991B1B" : "",
                          }}
                        >
                          <span
                            style={{
                              color:
                                period === option.value
                                  ? "text-white"
                                  : "text-rose-600",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {option.icon}
                          </span>
                          <span className="font-medium">{option.label}</span>
                        </motion.button>
                      ))}
                    </Box>

                    {/* Close Button */}
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleFilterClose}
                      className="w-full mt-4 py-3 rounded-xl border border-gray-200 bg-white text-gray-600 font-medium hover:bg-gray-50 hover:shadow-md transition-all cursor-pointer"
                    >
                      {t("Close")}
                    </motion.button>
                  </Box>
                </Popover>

                {loading && allProfiles.length === 0 ? (
                  <p className="text-center py-8 text-muted-foreground">
                    {t("Loading profiles...")}
                  </p>
                ) : allProfiles.length > 0 ? (
                  renderProfiles(allProfiles)
                ) : (
                  <p className="text-center py-8 text-muted-foreground">
                    {t("No profiles available for the selected filter")}
                  </p>
                )}

                {count === page ? null : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "2vh",
                    }}
                  >
                    <Button
                      className="w-full bg-maroon-gradient hover:bg-maroon-gradient cursor-pointer"
                      onClick={
                        token
                          ? () => setCount((count) => count + 1)
                          : () => setShowLoginDialog(true)
                      }
                      style={{
                        width: "auto",
                        height: "auto",
                        paddingTop: "9px",
                      }}
                    >
                      {t("View More")}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("You’re Almost There!")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Log in to explore profiles and start connecting")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-maroon-gradient hover:bg-maroon-gradient cursor-pointer"
              onClick={() => {
                setShowLoginDialog(false);
                navigate("/login"); // 👈 navigate to login screen
              }}
            >
              {t("Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog
        open={ShowSubscribeDialog}
        onOpenChange={setShowSubscribeDialog}
      >
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔔 {t("Subscription Required")}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-gray-600 mt-2">
              {t("Upgrade your plan to explore more matches")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setShowSubscribeDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-maroon-gradient hover:bg-maroon-gradient cursor-pointer"
              onClick={() => {
                setShowSubscribeDialog(false);
                navigate("/subscription");
                // dispatch(setCurrentPage("subscription"));
              }}
            >
              {t("Subscribe Now")}
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog
        open={openCompletionDialog}
        onOpenChange={setOpenCompletionDialog}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Your Journey Starts Here")}</AlertDialogTitle>

            <AlertDialogDescription>
              {t(
                "Complete your profile to unlock full access and explore profiles"
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setOpenCompletionDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-maroon-gradient hover:bg-maroon-gradient cursor-pointer"
              onClick={() => {
                setOpenCompletionDialog(false);
                navigate("/profile");
                dispatch(setCurrentPage("profile"));
              }}
            >
              {t("Continue")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default BrowsePage;
